import * as React from 'react';
import { SVGProps } from 'react';

const IconRingSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 1a1 1 0 0 0-1 1v.17A3.001 3.001 0 0 0 3 5v3h-.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H9V5a3.001 3.001 0 0 0-2-2.83V2a1 1 0 0 0-1-1zm0 10a1 1 0 0 0 1-1H5a1 1 0 0 0 1 1z" />
  </svg>
);
export default IconRingSizeXs;
